import type { FormulationSource, StatusPillVariant } from './types';

export const TEST_ID = 'formulationCurrentSummary';

export const SOURCE_PILL_VARIANT: Record<FormulationSource, StatusPillVariant> = {
    AGRIAN: 'warn',
    UNKNOWN: 'error',
    VERIFIED: 'ok'
};
